<template>
  <Section :title="gettext('Quelle est votre consommation de bois?')">
    <div class="grid grid--large grid--multiline">
      <div class="grid__item sm-w-1/2 lg-w-1/3">
        <FormGroup :field="consumptionField" :errors="consumptionErrors">
          <div class="field-group">
            <Input
              v-model="tempConsumptionValue"
              inputmode="numeric"
              pattern="[0-9]*"
            />
            <div class="field-group__addon">kilos</div>
          </div>
        </FormGroup>
      </div>
    </div>
  </Section>
</template>

<script setup>
import { ref, watch } from 'vue';

import Section from '@/components/simulation/Section.vue';
import FormGroup from '@/components/forms/FormGroup.vue';
import Input from '@/components/forms/fields/Input.vue';

import { useSimulation } from '@/composables/useSimulation';

const { simulation, updateSimulation, consumptionField } = useSimulation();

const consumptionErrors = ref([]);
const tempConsumptionValue = ref(simulation.woodConsumption);

watch(tempConsumptionValue, (value) => {
  consumptionErrors.value = [];
  const consumption = parseInt(value);

  /* eslint-disable-next-line eqeqeq */
  if (isNaN(consumption) || consumption != value) {
    consumptionErrors.value.push(gettext('Doit être un nombre.'));
    updateSimulation({ consumption: null, woodConsumption: null });
    return;
  }

  updateSimulation({
    consumption: consumption * 5.6, // 1 kg = 5.6 kWh
    woodConsumption: consumption,
    power: (consumption * 5.6) / 1500, // X kWH divided by 1500 hours
  });
});
</script>
